module.exports = __webpack_public_path__ + "img/img_cmag3.8c514942.png";